import React from 'react';
import { format, parse } from 'date-fns';

export interface Props {
  date: string;
}

const FormattedDate: React.FC<Props> = ({ date }) => (
  <React.Fragment>{format(parse(date, 'yyyy-MM-dd', new Date()), 'MMMM d, yyyy')}</React.Fragment>
);

export default FormattedDate;
